import React, { useState, useEffect } from 'react';
import PolTabNavigation from '../components/Analytics/POL/PolTabNavigation';
import PolPersonIdInput from '../components/Analytics/POL/PolPersonIdInput';
import PolOverviewTab from '../components/Analytics/POL/PolOverviewTab';
import PolLocationTab from '../components/Analytics/POL/PolLocationTab';
import PolActivityTab from '../components/Analytics/POL/PolActivityTab';
import PolRiskTab from '../components/Analytics/POL/PolRiskTab';
import { isDemoMode, setDemoMode as setDemoModeService, installDemoInterceptors } from '../services/demoMode';

const PatternOfLifeTest = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [personId, setPersonId] = useState('');
  const [demoMode, setDemoModeState] = useState(() => isDemoMode());

  // Install interceptors on mount if demo was previously enabled
  useEffect(() => {
    if (isDemoMode()) {
      installDemoInterceptors();
    }
  }, []);

  const handleDemoToggle = (enabled) => {
    setDemoModeService(enabled);
    setDemoModeState(enabled);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <h1 className="text-3xl font-bold mb-6">Subject Monitoring</h1>

      <PolPersonIdInput
        personId={personId}
        setPersonId={setPersonId}
        demoMode={demoMode}
        setDemoMode={handleDemoToggle}
      />
      <PolTabNavigation activeTab={activeTab} setActiveTab={setActiveTab} />

      {activeTab === 'overview' && <PolOverviewTab personId={personId} setActiveTab={setActiveTab} />}
      {activeTab === 'location' && <PolLocationTab personId={personId} />}
      {activeTab === 'activity' && <PolActivityTab personId={personId} />}
      {activeTab === 'risk' && <PolRiskTab personId={personId} />}
    </div>
  );
};

export default PatternOfLifeTest;
